/*eslint-disable no-unused-vars*/
import React from 'react';
const latinize = require('latinize');
/*eslint-enable no-unused-vars*/

function stringSanitizer(string) {
  // Handle umlauts.
  latinize.characters['Ą'] = 'A'
  latinize.characters['ą'] = 'a'
  latinize.characters['Ć'] = 'C'
  latinize.characters['ć'] = 'c'
  latinize.characters['Ę'] = 'E'
  latinize.characters['ę'] = 'e'
  latinize.characters['Ł'] = 'L'
  latinize.characters['ł'] = 'l'
  latinize.characters['Ń'] = 'N'
  latinize.characters['ń'] = 'n'
  latinize.characters['Ó'] = 'O'
  latinize.characters['ó'] = 'o'
  latinize.characters['Ś'] = 'S'
  latinize.characters['ś'] = 's'
  latinize.characters['Ź'] = 'Z'
  latinize.characters['ź'] = 'z'
  latinize.characters['Ż'] = 'Z'
  latinize.characters['ż'] = 'z'

  latinize.characters['і'] = 'i';
  latinize.characters['я'] = 'ia';

  string = latinize(string)

  // Remove any symbols and special characters.
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 -]+/g, '')
    .replace(/[ -]+/g, '-');
}

export default stringSanitizer;
